/**
 * Thông tin vật liệu của sản phẩm (Roary 09/10/2026): loại vật liệu, chiều rộng, độ dày, độ cứng / trạng thái tôi.
 *
 * Rộng và dày là SỐ kèm đơn vị, như khối lượng / 100. Không có "L" (ligne) như kích thước dây: ligne là cỡ mặt nút,
 * không phải đơn vị đo tấm / dây vật liệu.
 */
export const MATERIAL_SIZE_UNITS = ["mm", "cm", "inch"] as const;
export type MaterialSizeUnit = (typeof MATERIAL_SIZE_UNITS)[number];
export const DEFAULT_MATERIAL_SIZE_UNIT: MaterialSizeUnit = "mm";

/** "0.35 mm"; `null` khi chưa có số. Đơn vị trống (dữ liệu nhập ngoài biểu mẫu) thì coi là mm. */
export function formatMaterialSize(value: number | null | undefined, unit: string | null | undefined): string | null {
  if (value == null) return null;
  return `${value} ${unit || DEFAULT_MATERIAL_SIZE_UNIT}`;
}
